/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import Q_ColumnMatch from './Q_ColumnMatch';
import Q_MultipleChoice from './Q_MultipleChoice';
import Q_Order from './Q_Order';
import Q_SelectTrue from './Q_SelectTrue';
import Q_Type from './Q_Type';
import {usePersistentState} from "react-persistent-state";

export default function Question(props) {
  const question = props.question;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const setSubmission = props.setSubmission;

  var options = JSON.parse(localStorage.getItem('Options'));

  function sortOutQuestionTypes() {
    var content;
    if (question === undefined || question.type === undefined) return <></>;

    switch (question.type) {
      case 'single':
        content = <Q_MultipleChoice question={question} options = {options[questionNumber]} submission={submission} questionNumber={questionNumber} setSubmission={(x) => setSubmission(x)} />;
        break;
      case 'multiple':
        content = <Q_SelectTrue question={question} options = {options[questionNumber]} submission={submission} questionNumber={questionNumber} setSubmission={(x) => setSubmission(x)} />;
        break;
      case 'order':
        content = <Q_Order question={question} options = {options[questionNumber]} submission={submission} questionNumber={questionNumber} setSubmission={(x) => setSubmission(x)} />;
        break;
      case 'match':
        content = <Q_ColumnMatch question={question} options = {options[questionNumber]} submission={submission} questionNumber={questionNumber} setSubmission={(x) => setSubmission(x)} />;
        break;
      case 'number':
        content = <Q_Type question={question} options = {options[questionNumber]} submission={submission} questionNumber={questionNumber} setSubmission={(x) => setSubmission(x)} />;
        break;
      case 'text':
        content = <Q_Type question={question} submission={submission} questionNumber={questionNumber} setSubmission={(x) => setSubmission(x)} />;
        break;
      case 'true/false':
        content = <Q_MultipleChoice question={question} submission={submission} questionNumber={questionNumber} setSubmission={(x) => setSubmission(x)} />;
        break;
    }
    return <>{content}</>;
  }

  return (
    <>
      <link
        href={'https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.9.0/katex.min.css'}
        rel={'stylesheet'}
      />
      {sortOutQuestionTypes()}
    </>
  );
}
